module.exports = __webpack_public_path__ + "static/media/illustration-building-southeast.9f0660d7.png";